export const palette_llumar_atc = {
    "#ffffff" : {
        display: "Cam Filmi Yok",
        name: "Cam Filmi Yok",
        material: "01_default",
    },
    "#000000" : {
        display: "ATC 05",
        name: "ATC 05 CH SR HPR (Kömür)",
        material: "01_default",
    },
    "#313131" : {
        display: "ATC 15",
        name: "ATC 15 CH SR HPR (Kömür)",
        material: "01_default",
    },
    "#515151" : {
        display: "ATC 20",
        name: "ATC 20 CH SR HPR (Kömür)",
        material: "01_default",
    },
    "#616161" : {
        display: "ATC 35",
        name: "ATC 35 CH SR HPR (Kömür)",
        material: "01_default",
    },
    "#919191" : {
        display: "ATC 50",
        name: "ATC 50 CH SR HPR (Kömür)",
        material: "01_default",
    },
}

export const palette_llumar_atr = {
    "#ffffff" : {
        display: "Cam Filmi Yok",
        name: "Cam Filmi Yok",
        material: "01_default",
    },
    "#000000" : {
        display: "ATR 05",
        name: "ATR 05 CH SR HPR (Kömür)",
        material: "02_darker",
    },
    "#313131" : {
        display: "ATR 15",
        name: "ATR 15 CH SR HPR (Kömür)",
        material: "02_darker",
    },
    "#515151" : {
        display: "ATR 20",
        name: "ATR 20 CH SR HPR (Kömür)",
        material: "02_darker",
    },
    "#616161" : {
        display: "ATR 35",
        name: "ATR 35 CH SR HPR (Kömür)",
        material: "02_darker",
    },
    "#919191" : {
        display: "ATR 50",
        name: "ATR 50 CH SR HPR (Kömür)",
        material: "02_darker",
    },
}

export const palette_llumar_ctxi = {
    "#ffffff" : {
        display: "Cam Filmi Yok",
        name: "Cam Filmi Yok",
        material: "01_default",
    },
    "#000000" : {
        display: "CTXI 05",
        name: "CTXI 05 CH SR HPR",
        material: "02_darker",
    },
    "#313131" : {
        display: "CTXI 15",
        name: "CTXI 15 CH SR HPR",
        material: "02_darker",
    },
    "#616161" : {
        display: "CTXI 35",
        name: "CTXI 35 CH SR HPR",
        material: "02_darker",
    },
    "#919191" : {
        display: "CTXI 50",
        name: "CTXI 50 CH SR HPR",
        material: "02_darker",
    },
}

export const palette_llumar_air_pp = {
    "#ffffff" : {
        display: "Cam Filmi Yok",
        name: "Cam Filmi Yok",
        material: "01_default",
    },
    "#d5f9dd" : {
        display: "AIR 75 ",
        name: "AIR 75 IR SR HPR (Açık)",
        material: "01_default",
    },
    "#c0e8ef" : {
        display: "AIR 80",
        name: "AIR 80 BL SR HPR (Açık)",
        material: "01_default",
    },
    "#878681" : {
        display: "PP 60 ",
        name: "PP 60 GN SR HPR TitaniumGreen60",
        material: "01_default",
    },
}

export const palette_llumar_safety_scl = {
    "#ffffff" : {
        display: "Cam Filmi Yok",
        name: "Cam Filmi Yok",
        material: "01_default",
    },
    "#000000" : {
        display: "SA 05 PS 4",
        name: "SA 05 CH SR PS 4 (Kömür)",
        material: "01_default",
    },
    "#313131" : {
        display: "SA 15 PS 4",
        name: "SA 15 CH SR PS 4 (Kömür)",
        material: "01_default",
    },
    "#616161" : {
        display: "SA 35 PS 4",
        name: "SA 35 CH SR PS 4 (Kömür)",
        material: "01_default",
    },
    "#878681" : {
        display: "SCL PS 4",
        name: "SCL SR PS 4",
        material: "01_default",
    },
    "#000001" : {
        display: "SA 15 PS 8",
        name: "SA 15 CH SR PS 8 (Kömür)",
        material: "02_darker",
    },
    "#616162" : {
        display: "SA 35 PS 8",
        name: "SA 35 CH SR PS 8 (Kömür)",
        material: "02_darker",
    },
    "#878682" : {
        display: "SCL PS 8",
        name: "SCL SR PS 8 (Kömür)",
        material: "02_darker",
    },
}

export const palette_llumar_irx = {
    "#ffffff" : {
        display: "Cam Filmi Yok",
        name: "Cam Filmi Yok",
        material: "01_default",
    },
    "#000000" : {
        display: "IRX 05",
        name: "IRX 05 CH SR HPR (Kömür)",
        material: "02_darker",
    },
    "#313131" : {
        display: "IRX 15",
        name: "IRX 15 CH SR HPR (Kömür)",
        material: "02_darker",
    },
    "#616161" : {
        display: "IRX 35",
        name: "IRX 35 CH SR HPR (Kömür)",
        material: "02_darker",
    },
    "#919191" : {
        display: "IRX 50",
        name: "IRX 50 CH SR HPR (Kömür)",
        material: "02_darker",
    },
}

export const palette_llumar_legacy = {
    "#ffffff" : {
        display: "Cam Filmi Yok",
        name: "Cam Filmi Yok",
        material: "01_default",
    },
    "#36454f" : {
        display: "Charcoal LLumar ATC Serisi ",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#343434" : {
        display: "Jet Siyah LLumar ATC Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#1b1212" : {
        display: "Lcorice LLumar ATC Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#28282b" : {
        display: "Mat Siyah LLumar ATC Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
}